export function OrderDetail() {
  return <>ЗАХИАЛГЫН МЭДЭЭЛЭЛ</>
}
{
  /*주문상세*/
}
